<template>
  <div>
    <b-form-group
      :label="label"
    >
      <validation-provider
        #default="{ errors }"
        :rules="{required: require_ }"
        :name="`Funcao${itemAcesso}`"
      >
        <v-select
          ref="funcaoSelect"
          v-model="value_"
          :options="funcoes"
          label="nome"
          :clearable="false"
          :disabled="disabled"
          :filterable="false"
          @close="onTouch"
          @open="carregarFuncoes"
          @search="carregarFuncoesFiltradas"
          @input="enviarParaPai"
        />
        <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
      </validation-provider>
    </b-form-group>
  </div>
</template>

<script>
import {
  required,
} from '@validations'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import api from '@/app-modulo/comuns/funcao/shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'FuncaoSelect',
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    invalido: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: null,
    },
    itemAcesso: {
      type: Number,
      default: () => 0,
    },
    label: {
      type: String,
      default: 'Função',
    },
    require: {
      type: Boolean,
      default: true,
    },
    externo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      required,
      valueAttr: null,
      foiAcessado: false,
      funcoes: [],
      funcaoPrimeiroAcesso: true,
      nomeFuncao: '',
    }
  },
  computed: {
    require_: {
      get() {
        return this.require
      },
    },
    value_: {
      get() {
        return this.valueAttr ? this.valueAttr : this.value
      },
      set(newValue) {
        this.valueAttr = newValue
        return this.valueAttr
      },
    },
    isInvalido() {
      return this.invalido && this.foiAcessado
    },
  },
  /* eslint no-underscore-dangle: 0 */
  methods: {
    carregarFuncoes() {
      if (this.funcaoPrimeiroAcesso) {
        api.getFuncoesFiltradas(this.nomeFuncao, this.externo)
          .then(payload => {
            this.funcoes = payload.data
            this.funcaoPrimeiroAcesso = false
          })
          .catch(err => {
            this.$errorFormated(err.response)
            throw err
          })
      }
    },
    carregarFuncoesFiltradas(nomeFuncao) {
      this.nomeFuncao = nomeFuncao

      api.getFuncoesFiltradas(this.nomeFuncao, this.externo)
        .then(payload => {
          this.funcoes = payload.data
        })
        .catch(err => {
          this.$errorFormated(err.response)
          throw err
        })
    },
    propagarParaFilho() {
      this.$refs.funcaoSelect.focus()
    },
    enviarParaPai() {
      this.$emit('select', !this.value_ ? null : this.value_)
      this.$emit('input', !this.value_ ? null : this.value_)
    },
    onTouch() {
      this.foiAcessado = true
    },
    limpar() {
      this.value_ = []
    },
    mostrarErro(erro) {
      if (erro !== undefined && erro.includes(`O campo Funcao${this.itemAcesso} é obrigatório`)) {
        return 'O campo Função é obrigatório'
      }
      return erro
    },
  },
}
</script>
